import { Dialog, RadioGroup } from '@material-ui/core';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { CustomRadio } from '../../../../lib/CustomRadio';
import TextInput from '../../../../lib/TextField';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { RootStateType  } from "../../../../redux-store/reducers"
import { CLEAR_SIP_CANCEL_REASON, SET_SIP_CANCEL_REASON } from '../../../../redux-store/reducers/sipCancel';
import { CommercialRootPath, OTP_ACTIONS } from '../../../../utils/constants';
import { SipPaths } from './types';

const MAX_CHARACTER_LIMIT = 100;

export const SIPCancelReason = ({
  showDialog,
  setButtonClicked,
  setShowReasonDialog,
  callPauseApi,
  callCancelApi,
  sipCancelPayload,
  trxnType,
  disabled,
  remarks,
  reqId,
}: {
  showDialog: boolean;
  reqId: any;
  trxnType: 'CSIP' | 'PSIP';
  sipCancelPayload: any;
  setShowReasonDialog: any;
  callPauseApi: () => Promise<void>;
  callCancelApi: () => Promise<void>;
  setButtonClicked: any;
  disabled: boolean;
  remarks: string;
}) => {
  const { sipReasons, selectedSipReason } = useSelector(({ sipCancelReducer  } : RootStateType) => ({
    ...sipCancelReducer
  }))
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <Dialog maxWidth={'sm'} open={showDialog} aria-labelledby="transmission-main-modal">
      <div className="note-modals transmission-main-modal">
        <CustomRadio
          title="SIP Cancellation Reason"
          name="sip-cancel-reasons"
          formGroupClass="sip-cancel-radio"
          selectedValue={selectedSipReason?.code}
          list={sipReasons.map((sipReason) => ({ label: sipReason.reason, value: sipReason.code, cssClass: 'sip-cancel-label' }))}
          handleRadioChange={(value: string) => {
            dispatch({
              type: SET_SIP_CANCEL_REASON,
              body: {
                code: value,
                reason: value !== "13" ? sipReasons.find((sipReason) => sipReason.code === value)!.reason : '',
              }
            })
          }}
        />
        {selectedSipReason?.code === "13" &&
          <TextInput
            value={selectedSipReason.reason}
            placeholder='Please specify reason'
            onChange={(e) => {
              if(e.target.value.length > MAX_CHARACTER_LIMIT) return;
              dispatch({
                type: SET_SIP_CANCEL_REASON,
                body: {
                  code: "13",
                  reason: e.target.value
                }
              })
            }}
            variant="outlined"
          />
        }
        {remarks && <p style={{ marginLeft: '10px', fontSize: 16 }}> Note : {remarks} </p>}
        <div className="note-modals-btns">
          <SubmitButtonWithLoader
            className="customBtn"
            onClick={async () => {
              if (selectedSipReason?.code === '13' && selectedSipReason.reason.length === 0) return;
              try {
                  const otpPayload = {
                      reqId,
                      action: OTP_ACTIONS.sipPause,
                  };
                  const otpRes = await sendPhoneOTP(otpPayload)(dispatch);
                  const cancelApiPayload = {
                      data: [
                          {
                              ...sipCancelPayload.data[0],
                              code: selectedSipReason?.code,
                              reason: selectedSipReason?.reason
                          }
                      ]
                  }
                  dispatch({
                    type: CLEAR_SIP_CANCEL_REASON
                  })
                  history.push(`${CommercialRootPath}${SipPaths.SipOTP}`, {
                      apiPayload: cancelApiPayload,
                      reqId: otpRes.body.reqId,
                      pauseFlag: trxnType === 'PSIP',
                      otpRef: otpRes.body.otpRef,
                  });
              } catch (err: any) {
                alert(err.message);
              }
            }}
            disabled={disabled}
            label="Proceed with cancel"
          />
          <SubmitButtonWithLoader
            className="customBtn"
            onClick={async () => {
              setShowReasonDialog(false);
              setButtonClicked(null);
              dispatch({
                type: CLEAR_SIP_CANCEL_REASON
              })
            }}
            disabled={disabled}
            label="Go Back"
          />
        </div>
      </div>
    </Dialog>
  )
}

